export interface PdfExportPreferences {
  includeScorecard: boolean
  includeShortTranscript: boolean
  includeTranscript: boolean
}

export const PDF_EXPORT_PREFERENCES_STORAGE_KEY =
  'interviewPdfExportPreferences'

export const defaultPdfExportPreferences: PdfExportPreferences = {
  includeScorecard: true,
  includeShortTranscript: false,
  includeTranscript: false,
}

function isPreferenceValue(value: unknown): value is boolean {
  return typeof value === 'boolean'
}

export function loadPdfExportPreferences(): PdfExportPreferences {
  if (typeof window === 'undefined') {
    return defaultPdfExportPreferences
  }

  const rawPreferences = window.localStorage.getItem(
    PDF_EXPORT_PREFERENCES_STORAGE_KEY,
  )

  if (!rawPreferences) {
    return defaultPdfExportPreferences
  }

  try {
    const parsedPreferences = JSON.parse(
      rawPreferences,
    ) as Partial<PdfExportPreferences>

    return {
      includeScorecard: isPreferenceValue(parsedPreferences.includeScorecard)
        ? parsedPreferences.includeScorecard
        : defaultPdfExportPreferences.includeScorecard,
      includeShortTranscript: isPreferenceValue(
        parsedPreferences.includeShortTranscript,
      )
        ? parsedPreferences.includeShortTranscript
        : defaultPdfExportPreferences.includeShortTranscript,
      includeTranscript: isPreferenceValue(parsedPreferences.includeTranscript)
        ? parsedPreferences.includeTranscript
        : defaultPdfExportPreferences.includeTranscript,
    }
  } catch {
    return defaultPdfExportPreferences
  }
}

export function savePdfExportPreferences(
  preferences: PdfExportPreferences,
): void {
  if (typeof window === 'undefined') {
    return
  }

  window.localStorage.setItem(
    PDF_EXPORT_PREFERENCES_STORAGE_KEY,
    JSON.stringify(preferences),
  )
}
